import { FC } from "react";
import { useTranslation } from "react-i18next";
import Breadcrumbs from "@dashboard/components/breadcrumbs/breadcrumbs";
import { UiButton } from "@domun/component-library";
import { DeliveryPageWrapper } from "../../components/delivery-page-layout/delivery-page-layout.styled";
import { useDeliverySettings } from "../../hooks/use-delivery-settings.hook";

const DeliverySettings: FC = () => {
  const { t } = useTranslation();
  const {
    form,
    updateField,
    estimatedTimes,
    loading,
    handleSave,
    goToCoverage,
    goToProfile,
    breadcrumbs,
  } = useDeliverySettings();

  const hasMainOptionEnabled =
    form.customDeliveryEnabled ||
    form.nationalLogisticEnabled ||
    form.storeDelivery;

  return (
    <DeliveryPageWrapper>
      <div className="header">
        <Breadcrumbs items={breadcrumbs} backButton />
      </div>
      <h2>{t("delivery.settings.title")}</h2>

      <div className="card">
        <h3>{t("delivery.settings.local.title")}</h3>
        <div className="toggle-row">
          <span>{t("delivery.settings.local.enabled")}</span>
          <input
            type="checkbox"
            checked={form.customDeliveryEnabled}
            onChange={(e) =>
              updateField("customDeliveryEnabled", e.target.checked)
            }
          />
        </div>
        {form.customDeliveryEnabled && (
          <div className="field">
            <label>{t("delivery.settings.local.price")}</label>
            <input
              type="number"
              min={0}
              value={form.customDeliveryValue}
              onChange={(e) =>
                updateField("customDeliveryValue", Number(e.target.value))
              }
            />
          </div>
        )}
        {form.customDeliveryEnabled && (<div className="toggle-row">
          <span>{t("delivery.settings.local.freeShipping")}</span>
          <input
            type="checkbox"
            checked={form.localFreeEnabled}
            onChange={(e) => updateField("localFreeEnabled", e.target.checked)}
          />
        </div>)}
        {form.customDeliveryEnabled && form.localFreeEnabled && (
          <div className="field">
            <label>{t("delivery.settings.local.minOrder")}</label>
            <input
              type="number"
              min={0}
              value={form.localFreeMin}
              onChange={(e) =>
                updateField("localFreeMin", Number(e.target.value))
              }
            />
          </div>
        )}
      </div>

      <div className="card">
        <h3>{t("delivery.settings.national.title")}</h3>
        <div className="toggle-row">
          <span>{t("delivery.settings.national.enabled")}</span>
          <input
            type="checkbox"
            checked={form.nationalLogisticEnabled}
            onChange={(e) =>
              updateField("nationalLogisticEnabled", e.target.checked)
            }
          />
        </div>
        {form.nationalLogisticEnabled && (
          <div className="field">
            <label>{t("delivery.settings.national.price")}</label>
            <input
              type="number"
              min={0}
              value={form.nationalDeliveryValue}
              onChange={(e) =>
                updateField("nationalDeliveryValue", Number(e.target.value))
              }
            />
          </div>
        )}
        {form.nationalLogisticEnabled && (<div className="toggle-row">
          <span>{t("delivery.settings.national.freeShipping")}</span>
          <input
            type="checkbox"
            checked={form.nationalFreeEnabled}
            onChange={(e) =>
              updateField("nationalFreeEnabled", e.target.checked)
            }
          />
        </div>)}
        {form.nationalLogisticEnabled && form.nationalFreeEnabled && (
          <div className="field">
            <label>{t("delivery.settings.national.minOrder")}</label>
            <input
              type="number"
              min={0}
              value={form.nationalFreeMin}
              onChange={(e) =>
                updateField("nationalFreeMin", Number(e.target.value))
              }
            />
          </div>
        )}
      </div>

      <div className="card">
        <h3>{t("delivery.settings.pickup.title")}</h3>
        <div className="toggle-row">
          <span>{t("delivery.settings.pickup.enabled")}</span>
          <input
            type="checkbox"
            checked={form.storeDelivery}
            onChange={(e) => updateField("storeDelivery", e.target.checked)}
          />
        </div>
        <button type="button" className="link-button" onClick={goToProfile}>
          {t("delivery.settings.pickup.manageAddress")}
        </button>
      </div>

      {estimatedTimes.length > 0 && (
        <div className="card">
          <h3>{t("delivery.settings.estimatedTime.title")}</h3>
          <div className="field">
            <label>{t("delivery.settings.estimatedTime.local")}</label>
            <select
              value={form.estimatedDeliveryTimeId}
              onChange={(e) =>
                updateField("estimatedDeliveryTimeId", e.target.value)
              }
            >
              <option value="">—</option>
              {estimatedTimes.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.label}
                </option>
              ))}
            </select>
          </div>
          <div className="field">
            <label>{t("delivery.settings.estimatedTime.national")}</label>
            <select
              value={form.nationalEstimatedDeliveryTimeId}
              onChange={(e) =>
                updateField("nationalEstimatedDeliveryTimeId", e.target.value)
              }
            >
              <option value="">—</option>
              {estimatedTimes.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      )}

      {/* <button type="button" className="link-button" onClick={goToCoverage}>
        {t("delivery.settings.coverageLink")}
      </button> */}

      <div className="actions">
        <UiButton
          onClick={handleSave}
          isLoading={loading}
          disabled={loading || !hasMainOptionEnabled}
        >
          {t("delivery.settings.save")}
        </UiButton>
      </div>
    </DeliveryPageWrapper>
  );
};

export default DeliverySettings;
